// @ts-ignore
/* eslint-disable */
import request from "../../utils/request";

/** 获取相关oss配置 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /oss/config-info */
export async function ossConfigInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossConfigInfoUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultOssConfigInfoResp>("/oss/config-info", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 生成预签名url # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /oss/generate-presign-url */
export async function ossGeneratePresignUrlUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.ossGeneratePresignUrlUsingGETParams,
  options?: { [key: string]: any }
) {
  return request<API.BaseResultURL>("/oss/generate-presign-url", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
